var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"social-link",attrs:{"target":"_blank","href":_vm.url}},[_c('img',{attrs:{"src":require(`@/assets/img/${_vm.src}`),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }